import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SuccessAction from '../actions/SuccessAction';
// import PlansAction from '../actions/PlansAction';
import Success from '../../components/Success/Success';
import { SuccessSelector } from '../reducers/SuccessReducer';
import { ConfigSelector } from '../reducers/ConfigReducer';
import { PlansSelector } from '../reducers/PlansReducer';

const mapStateToProps = state => ({
  partner: SuccessSelector.getPartner(state),
  isFixedTerm: SuccessSelector.getContract(state),
  plan: SuccessSelector.getPlan(state),
  offer: ConfigSelector.getGiftWithPurchase(state),
  discountWithSubscription: ConfigSelector.getDiscountWithSubscription(state),
  isUfbReady: PlansSelector.getUfbReady(state),
  isUfbAvailable: PlansSelector.getUfbAvailable(state),
  lockDownEndDate: ConfigSelector.getLockDownEndDate(state),
  isCovid19Mode: ConfigSelector.isCovid19Mode(state),
  withMobileDiscount: PlansSelector.checkWithMobileDiscount(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    clearSuccessDetails: SuccessAction.clearSuccessDetails,

    // resetPlans: PlansAction.resetPlans
  }, dispatch);

const SuccessContainer = connect(mapStateToProps, mapDispatchToProps)(Success);

export default SuccessContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/SuccessContainer.js
 **/